import useOptions from "../useSelectOptions/useSelectOptions";
import { mapCoverDataToOptions } from "../../../utils/mapDataToOptions";

const useCoverOptions = (endpoint) => {
  return useOptions(endpoint, mapCoverDataToOptions);
};

export default useCoverOptions;
